// removed by extract-text-webpack-plugin
module.exports = {"Tag":"_1ox46n4_kNIU_DSk6RyBLt","Tags":"x5wfj3gvA8NK-iBk3JHOl","RemoveTag":"CSZDIEqOEJ9YvW7_Eds7i","TagInput":"gPPIdtIPKmpY_tc6ICVtE","TagInputField":"y-MiqUr5xK03npJRi6rUK"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Tags/style.css
// module id = 1711
// module chunks = 0